import React, { ReactNode } from 'react';

import { colorsSelector } from '@redux/colorPalette/selectors';
import { useSelector } from 'react-redux';

import { RootContainer } from './Root.style';

interface Props {
  children: ReactNode;
}

const Root: React.FunctionComponent<Props> = ({ children }) => {
  const colors = useSelector(colorsSelector);
  return <RootContainer {...{ colors }}>{children}</RootContainer>;
};

export default Root;
